import { useSetCookie } from '@haaretz/s-atoms/cookie';
import { useSetUser } from '@haaretz/s-atoms/user';
import { useZenModeSetter } from '@haaretz/s-atoms/zenMode';
import useLogoutMutation from '@haaretz/s-client-data-hooks/sso/useLogout';
import { useQueryClient } from '@tanstack/react-query';

import type { LogoutOutput } from '@haaretz/s-data-structure-types';

export default function useLogout({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: LogoutOutput) => void;
  onError?: (data: Error) => void;
}) {
  const client = useQueryClient();
  const updateUser = useSetUser();
  const updateZenMode = useZenModeSetter();
  const updateCookie = useSetCookie();

  const logout = useLogoutMutation({
    onSuccess: async data => {
      if (data.success) {
        updateUser('logout', () => client.clear());

        updateCookie();
        updateZenMode(false);
      }
      /* istanbul ignore else */
      if (typeof onSuccess === 'function') {
        onSuccess(data);
      }
    },
    onError,
  });

  return logout;
}
